module.exports = __webpack_public_path__ + "media/assets/images/category/Congrats@2x-5d7b09582bf4af27d506ff91dd994213.png";